<template>
  <div :class="{'english': isenglish ,'japanese': isjapanese ,'content_style':true}">
    <div class="index_topimg">
      <img src="../assets/img/index_topimg.png" alt="">
      <!-- <div class="index_man">
         <div class="index_manimg"></div>
      </div> -->
    </div>
    <div class="index_bluetit">服务</div>
    <div class="index_content">
      <div class="index_service">
        <div class="index_service_item">
          <div class="index_service_tit">在线人工｜人工智能</div>
          <div class="index_service_desc">制药公司专业人员为你回答所有问题Chat GPT✖CGM医药数据库</div>
          <img src="../assets/img/indexs_icon1.png" alt="">
        </div>
        <div class="index_service_item">
          <div class="index_service_tit">过期免费更换</div>
          <div class="index_service_desc">未开封的药品可申请免费更换新日期药品包含所有国际运费</div>
          <img src="../assets/img/indexs_icon2.png" alt="">
        </div>
        <div class="index_service_item">
          <div class="index_service_tit">私人家庭医生服务微信群</div>
          <div class="index_service_desc">医药团队客服/CGM Medical平台医生团队为你的家庭服务</div>
          <img src="../assets/img/indexs_icon3.png" alt="">
        </div>
      </div>
      <div class="index_bluetit">CGM制药的家庭配置药是什么？</div>
      <div class="index_pzydescribe index_blueborder">
          <div class="index_bluecircle index_pzydescribe1">
            <img src="../assets/img/index_pzydescribe1.png" alt="">
          </div>
          <div class="index_bluecircle index_pzydescribe2">
            <img src="../assets/img/index_pzydescribe2.png" alt="">
          </div>
          <div class="index_bluecircle index_pzydescribe3">
            <img src="../assets/img/index_pzydescribe3.png" alt="">
          </div>
          <div class="index_pzydescribe_text">致力于全球家庭用药领域</div>
          <div class="index_pzydescribe_text">我们面向全球500万个家庭提供家庭用药全部类目</div>
          <div class="index_pzydescribe_text">日本发往全世界、为家庭健康服务</div>
          <div class="index_pzydescribe_boldtext">适合的家庭群体</div>
          <div class="index_pzydescribe_text">工作较忙压力大没有时间购买药品</div>
          <div class="index_pzydescribe_text">临时症状立刻自我治疗</div>
          <div class="index_pzydescribe_text">季节的需求自由选择用药</div>
      </div>
      <div class="index_bluetit">家庭配置药的特点</div>
      <div class="index_specials index_blueborder">
          <div class="index_bluecircle index_specials1">
            <img src="../assets/img/indexspecial1.png" alt="">
          </div>
          <div class="index_bluecircle index_specials2">
            <img src="../assets/img/indexspecial2.png" alt="">
          </div>
          <div class="index_bluecircle index_specials3">
            <img src="../assets/img/indexspecial3.png" alt="">
          </div>
          <div class="index_specialcont">
               <div class="index_specialtit"><span class="num">01</span> <span class="snumtit">会员邀请制 申请配置药</span></div>
               <div class="index_specialtxt first">根据家庭的情况可选择多种类CGM制药的医药品进行配置。</div>
               <div class="index_specialtit"><span class="num">02</span> <span class="snumtit">国际安全配送  全程查阅链路 申请配置药</span>
 </div>
               <div class="index_specialtxt">PROPHARMA Express全资物流公司为您全程担保配送。完善海关缴纳关税及备案手续、合法合规安全可靠。</div>
               <div class="index_specialtit"><span class="num">03</span> <span class="snumtit">新时代  用药方式</span></div>
               <div class="index_specialtxt">提高自我治疗意识、避免医院拥挤或二次感染。 未开封的过期药品可以申请免费更换。</div>
          </div>
      </div>
      <div class="index_bluetit mb60">家庭配置药国际送达流程</div>
      <div class="process_style">
        <div class="pro_left_style">
          <div class="process_style1" @click="img_click(0)">
            <div
              class="process_style2"
              :style="[
                { background: index == 0 ? '#f03b49' : '' },
                { color: index == 0 ? '#fff' : '' },
              ]"
            >
              <div class="st_style">STEP</div>
              <div class="num_style">1</div>
            </div>
            <div
              class="p_style"
              :style="[{ color: index == 0 ? '#223344' : '' }]"
            >
              注册登录・个人信息
            </div>
          </div>
          <div class="process_style1" @click="img_click(1)">
            <div
              class="process_style2"
              :style="[
                { background: index == 1 ? '#f03b49' : '' },
                { color: index == 1 ? '#fff' : '' },
              ]"
            >
              <div class="st_style">STEP</div>
              <div class="num_style">2</div>
            </div>
            <div
              class="p_style"
              :style="[{ color: index == 1 ? '#223344' : '' }]"
            >
              查看配置药介绍
            </div>
          </div>
          <div class="process_style1" @click="img_click(2)">
            <div
              class="process_style2"
              :style="[
                { background: index == 2 ? '#f03b49' : '' },
                { color: index == 2 ? '#fff' : '' },
              ]"
            >
              <div class="st_style">STEP</div>
              <div class="num_style">3</div>
            </div>
            <div
              class="p_style"
              :style="[{ color: index == 2 ? '#223344' : '' }]"
            >
              国际支付
            </div>
          </div>
          <div class="process_style1" @click="img_click(3)">
            <div
              class="process_style2"
              :style="[
                { background: index == 3 ? '#f03b49' : '' },
                { color: index == 3 ? '#fff' : '' },
              ]"
            >
              <div class="st_style">STEP</div>
              <div class="num_style">4</div>
            </div>
            <div
              class="p_style"
              :style="[{ color: index == 3 ? '#223344' : '' }]"
            >
              国际配送
            </div>
          </div>
          <div class="process_style1" @click="img_click(4)">
            <div
              class="process_style2"
              :style="[
                { background: index == 4 ? '#f03b49' : '' },
                { color: index == 4 ? '#fff' : '' },
              ]"
            >
              <div class="st_style">STEP</div>
              <div class="num_style">5</div>
            </div>
            <div
              class="p_style"
              :style="[{ color: index == 4 ? '#223344' : '' }]"
            >
              家庭医生微信群
            </div>
          </div>
          <div class="process_style1" @click="img_click(5)">
            <div
              class="process_style2"
              :style="[
                { background: index == 5 ? '#f03b49' : '' },
                { color: index == 5 ? '#fff' : '' },
              ]"
            >
              <div class="st_style">STEP</div>
              <div class="num_style">6</div>
            </div>
            <div
              class="p_style"
              :style="[{ color: index == 5 ? '#223344' : '' }]"
            >
              补充药品
            </div>
          </div>
        </div>
        <div class="st_layout_style">
          <el-carousel
            ref="remarkCarusel"
            indicator-position="none"
            :initial-index="0"
            trigger="click"
            direction="vertical"
            :autoplay="false"
          >
            <el-carousel-item
              v-for="(item, index) in carousel_list1"
              :key="index"
            >
              <div class="ste_style">
                <img :src="item.img" class="m_style" />
                <div class="st_style1">
                  {{ item.name }}
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="index_bluetit">家庭配置药</div>
      <div class="index_blacktitdes">我们不断的推出新系列供您选择最适合您家庭的医药品</div>
      <div class="index_attention">
         <div class="index_attentionleft">Serve</div>
         <div class="index_attention_txt">三个药品以上包邮国际运费</div>
         <div class="index_attention_txt">未开封过期药品免费更换</div>
         <div class="index_attention_txt">不明症状请在私人家庭微信群咨询客服人员</div>
      </div>
      <div class="two_medicinebag">
        <div class="two_bag clearfix">
          <div class="twobag"  v-for="item in package_list" :key="item.packageId">
            <div class="twobgitem">
              <div class="twobagtop">
                  <img class="twobagimg" :src="item.packageImg" alt="">
                  <div class="clearfix twobagbottext">
                    <div class="twobagtxtbox fl">
                      <div class="twobgtxt">{{item.packageIntroduce}}</div>
                      <div class="twobgtxt">{{item.packageName}} <span>{{item.rmbAmount}}元</span></div>
                    </div>
                    <div class="fr twobgtxtbtn" v-if="item.show!=0" @click="close(item.packageId)">已展开</div>
                    <div class="fr twobgtxtbtn" v-else @click="cgmSpuList2(item.packageId)">展开查看</div>
                  </div>
              </div>
              <div class="twobagbot">
                  <div class="twobagleft">CGM Pay国际支付安全有保障</div>
                  <div class="twobagleft on" @click="package_click(item.packageId)">申请配置药</div>
              </div>
            </div>
            <div class="tbl phone" v-if="item.show!=0&spu_list2.length>0">
          <div v-for="item1 in spu_list2"
                    :key="item1.categoryId">
                <div class="index_medicinetit">{{ item1.categoryName }}</div>
                <div class="spu_coll_style">
                    <div
                      v-for="item in item1.cgmSpuList"
                      :key="item.spuId"
                      class="spu_list_style"
                    >
                      <div class="index_medicineborder">
                        <img :src="item.spuImg" alt="" class="spu_img_style" />
                        <div class="index_medicinebcont">
                          <div class="index_guge">规格：<span 
                            v-for="item in item.cgmSpuOptionList"
                          :key="item.labelId"> {{ item.optionValue }}{{ item.optionName }}</span> </div>
                          <div class="index_guge index_fl">
                            标签： <span 
                            v-for="item in item.cgmLabelList"
                          :key="item.labelId"> {{ item.labelName }}</span> 
                          </div>
                          <div class="spu_name_style">{{ item.spuName }}</div>
                        </div>
                      </div>
                      <div class="spu_style1" @click="check_click(item.spuId)">
                        查看详情
                      </div>
                    </div>
                </div>
            </div>
            <div class="twobags" @click="close(nowpackageId)">收起</div>
          </div>
            </div>
         
          
        </div>
      </div>
      <div class="tbl pc" v-if="spu_list2.length>0">
        <div v-for="item1 in spu_list2"
                :key="item1.categoryId">
            <div class="index_medicinetit">{{item1.categoryName}}</div>
            <div class="spu_coll_style">
                <div
                  v-for="item in item1.cgmSpuList"
                  :key="item.spuId"
                  class="spu_list_style"
                >
                  <div class="index_medicineborder">
                    <img :src="item.spuImg" alt="" class="spu_img_style" />
                    <div class="index_medicinebcont">
                      <div class="index_guge">规格：<span 
                        v-for="item in item.cgmSpuOptionList"
                      :key="item.labelId"> {{ item.optionValue }}{{ item.optionName }}</span> </div>
                      <div class="index_guge index_fl">
                        标签： <span 
                        v-for="item in item.cgmLabelList"
                      :key="item.labelId"> {{ item.labelName }}</span> 
                      </div>
                      <div class="spu_name_style">{{ item.spuName }}</div>
                    </div>
                  </div>
                  <div class="spu_style1" @click="check_click(item.spuId)">
                    查看详情
                  </div>
                </div>
            </div>
        </div>
        <div class="twobags" @click="close(nowpackageId)">收起</div>
      </div>
      <!-- <div v-if="configFlag > 0">
        <div v-for="item1 in spulist"
                :key="item1.categoryId">
            <div class="index_medicinetit">{{item1.categoryName}}</div>
            <div class="spu_coll_style">
                <div
                  v-for="item in item1.cgmSpuList"
                  :key="item.spuId"
                  class="spu_list_style"
                >
                  <div class="index_medicineborder">
                    <img :src="item.spuImg" alt="" class="spu_img_style" />
                    <div class="index_medicinebcont">
                      <div class="index_guge">规格：<span 
                        v-for="item in item.cgmSpuOptionList"
                      :key="item.labelId"> {{ item.optionValue }}{{ item.optionName }}</span> </div>
                      <div class="index_guge index_fl">
                        分类： <span 
                        v-for="item in item.cgmLabelList"
                      :key="item.labelId"> {{ item.labelName }}</span> 
                      </div>
                      <div class="spu_name_style">{{ item.spuName }}</div>
                    </div>
                  </div>
                  <div class="spu_style1" @click="check_click(item.spuId)">
                    查看详情"
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div v-else>
        <div v-for="item1 in spu_list2"
                :key="item1.categoryId">
            <div class="index_medicinetit">{{item1.categoryName}}</div>
            <div class="spu_coll_style">
                <div
                  v-for="item in item1.cgmSpuList"
                  :key="item.spuId"
                  class="spu_list_style"
                >
                  <div class="index_medicineborder">
                    <img :src="item.spuImg" alt="" class="spu_img_style" />
                    <div class="index_medicinebcont">
                      <div class="index_guge">规格：<span 
                        v-for="item in item.cgmSpuOptionList"
                      :key="item.labelId"> {{ item.optionValue }}{{ item.optionName }}</span> </div>
                      <div class="index_guge index_fl">
                        分类： <span 
                        v-for="item in item.cgmLabelList"
                      :key="item.labelId"> {{ item.labelName }}</span> 
                      </div>
                      <div class="spu_name_style">{{ item.spuName }}</div>
                    </div>
                  </div>
                  <div class="spu_style1" @click="check_click(item.spuId)">
                    查看详情"
                  </div>
                </div>
            </div>
        </div>
      </div>
      <div class="index_mdeicinebox">
        <div class="idex_medicinebtn">合计（{{number}}）{{total}} RMB</div>
        <div class="idex_medicinebtn">国际运费 包邮"</div> 
        <div class="idex_medicinebtn blue" @click="package_click('1731336393415692289')">申请配置药"</div>
      </div> -->
      <div class="index_bluetit">家庭配置药</div>
      <div class="index_blacktitdes">关于所有医药品的制药公司</div>
      <div class="index_cooperate_group">
          <!-- <img class="index_cooperate_item"  @click="company_click('https://www.baidu.com/')" src="../assets/img/Group1.png" alt=""> -->
          <img class="index_cooperate_item" src="../assets/img/Group1.png" alt="">
          <img class="index_cooperate_item" src="../assets/img/Group2.png" alt="">
          <img class="index_cooperate_item" src="../assets/img/Group3.png" alt="">
          <img class="index_cooperate_item" src="../assets/img/Group4.png" alt="">
          <img class="index_cooperate_item" src="../assets/img/Group5.png" alt="">
          <img class="index_cooperate_item" src="../assets/img/Group6.png" alt="">
          <img class="index_cooperate_item" src="../assets/img/Group7.png" alt="">
          <img class="index_cooperate_item" src="../assets/img/Group8.png" alt="">
      </div>
      <div class="index_bluetit">请在此处查看常见问题和支持环境</div>
      <div class="question_style1" @click="question_click">
        <div style="font-size: 22px"><i class="el-icon-question"></i></div>
        <div class="commonly_question_style">常见问题</div>
      </div>
    </div>
  </div>
</template>
<script>
import { medical_href } from "../assets/config/img";
import { mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState(["cgmUserVO", "leftItem", "mobile"]),
  },
  data() {
    return {
      configFlag: null,
      nowpackageId:'',
      index: 0,
      number:0,
      total:0,
      mouthItem: 1,
      spu_list: [],
      spu_list2: [],
      package_list: [],
      spulist:[],
      carousel_list: [
        require("../assets/img/step2.svg"),
        require("../assets/img/step3.svg"),
        require("../assets/img/step4.svg"),
        require("../assets/img/step5.svg"),
        require("../assets/img/step6.png"),
      ],
      carousel_list1: [
        {
          name: "真实个人信息、申请家庭配置药。邀请制：请填写邀请码。填写您的家庭状况、让我们更精准的了解、为您的家庭提供个性化用药。",
          img: require("../assets/img/step1.svg"),
        },
        {
          name: "详细查看家庭配置药基础系列的介绍、申请进行配置。",
          img: require("../assets/img/step2.svg"),
        },
        {
          name: "CGM Pay国际支付担保、可选择中国的主流支付方式：微信 支付宝。",
          img: require("../assets/img/step3.svg"),
        },
        {
          name: "CGM公司旗下全资医药品专门物流公司、CGM Express、为您的药品全额担保、保障安全送达。",
          img: require("../assets/img/step4.svg"),
        },
        {
          name: "CGM制药客服为您的家庭创建家庭医生微信群、为每个家庭提供用药指导和永久免费的医疗知识服务。",
          img: require("../assets/img/step5.svg"),
        },
        {
          name: "58种以上的家庭用药任您补充！",
          img: require("../assets/img/step6.png"),
        },
      ],
      categoryId: null,
      nowtxt:'展开查看',
      isenglish:false,
      isjapanese:false,
    };
  },
  beforeCreate(){
  },
  created(){
   
  },
  mounted() {
    // this.language = window.translate.language.getCurrent();
    // if(this.language == "english"){
    //   this.isenglish = true
    // }
    // if(this.language == "japanese"){
    //   this.isjapanese = true
    // }
    if (this.cgmUserVO) {
      let userId = JSON.parse(this.cgmUserVO).userId;
      this.axios
        .get("/cgmOrder/getOrderCount", {
          params: {
            userId,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.configFlag = res.data.data;
            if(res.data.data > 0){
              this.$router.push("/ConfigMedicine");
            }
          }
        });
      }
    // document.querySelector('.footer').setAttribute('style','background:#fff')
    // document.querySelector('.foo_style').setAttribute('style','background:#E8F7FF')
    // if (this.cgmUserVO) {
    //   let userId = JSON.parse(this.cgmUserVO).userId;
    //   this.axios
    //     .get("/cgmOrder/getOrderCount", {
    //       params: {
    //         userId,
    //       },
    //     })
    //     .then((res) => {
    //       if (res.data.code == 200) {
    //         this.configFlag = res.data.data;
    //         if(res.data.data>0){
    //           this.cgmSpuListed()
    //         }else{
    //           // this.cgmSpuList();
    //           this.cgmSpuList2();
    //         }
    //       }
    //     });
    // }
    this.cgmPackageList();
  },
  methods: {
    close(id){
      this.spu_list2 = []
      for(var i=0;i<this.package_list.length;i++){
          if(id == this.package_list[i].packageId){
            this.package_list[i].show = 0;
          }else{
            // if(this.package_list[i].show == 0){
            //   this.package_list[i].show = 1;
            // }
           
              }
        }
    },
    config_check_click() {
      if (this.mobile) {
        this.$router.push({
          path: "/spuAppend",
          query: {
            packageId: "1731336393415692289",
          },
        });
      } else {
        this.$router.push({
          path: "/SpuConfig",
          query: {
            packageId: "1731336393415692289",
          },
        });
      }
    },
    mouthItemClick(v) {
      this.mouthItem = v;
      this.cgmSpuList();
    },
    img_click(v) {
      this.index = v;
      this.$refs.remarkCarusel.setActiveItem(v);
    },
    check_click(spuId) {
      this.$router.push({
        path: "/spuDetail",
        query: {
          spuId,
        },
      });
    },
    question_click() {
      this.$router.push({
        path: "/question",
      });
    },
    cgmSpuList() {
      if (this.mouthItem == 1) {
        this.categoryId = "1731336549590601730";
      } else {
        this.categoryId = "1731336549590601731";
      }
      this.axios
        .get("/cgmSpu/list", {
          params: {
            categoryId: this.categoryId,
          },
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.spu_list = res.data.data;
          }
        });
    },
    cgmSpuList2(id) {
      this.nowpackageId = id;
      this.axios
        .get("/cgmCategory/listNotConfigured?packageId="+id)
        .then((res) => {
          if (res.data.code == 200) {
            this.spu_list2 = res.data.data;
            for(var i=0;i<this.package_list.length;i++){
              if(id == this.package_list[i].packageId){
                this.package_list[i].show = 1;
              }else{
                this.package_list[i].show = 0;
              }
            }
            console.log(this.spu_list2)

          }
        }).catch(err => console.log(err));
    },
    cgmSpuListed() {
      this.axios
        .get("/cgmCategory/listConfigured")
        .then((res) => {
          if (res.data.code == 200) {
            this.spulist = res.data.data;
          }
        });
    },
    cgmPackageList() {
      this.axios
        .get("/cgmPackage/list", {
          params: {},
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.package_list = res.data.data;
            this.number = res.data.data[0].cgmSpuList.length;
            this.total = res.data.data[0].rmbAmount;
          }
          
        });
    },
    package_click(packageId) {
      this.$router.push({
        path: "/spu",
        query: {
          packageId,
        },
      });
    },
    company_click(e) {
      window.open(e, '_bank')
    },
    medical_click() {
      window.open(medical_href);
    },
  },
};
</script>
<style lang="scss">
.index_topimg{
  position: relative;
}
.index_topimg .index_man{
    width: 80%;
    height: 168px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 100px;
   margin:auto;
   overflow: hidden;
}
.index_manimg{
    width: 1962px;
    height: 168px;
    background: url(../assets/img/index_man.png);
    background-size:981px 168px;
    animation:  translatex 26s linear 0s infinite normal;
}
@keyframes translatex {
    0% {
        transform: translateX(0)
    }

    100% {
        transform: translateX(-981px)
    }
   }
@media screen and (min-width: 768px) {
  .what_style1 {
    display: none;
  }
}
@media screen and (max-width: 768px) {
  .index_topimg .index_man{
    height: 70px;
    bottom:40px;
  }
  .index_manimg{
    height:70px;
    background-size: 500px 70px;
  }
  .what_style {
    display: none;
  }
  // .spu_img_style {
  //   width: 120px !important;
  // }

  .des_style {
    flex-wrap: wrap;
    padding: 20px 20px 0 20px !important;
    font-size: 20px !important;
  }
  .d_style > div {
    text-align: center;
  }
  .carousel_style {
    width: 200px !important;
    height: 180px !important;
    margin-top: 20px;
  }
  .carousel_img_style {
    height: 160px !important;
  }
  ::v-deep .el-carousel__container {
    height: 370px !important;
  }
  .special_style {
    justify-content: flex-start !important;
    flex-wrap: wrap;
  }
  .global_style {
    -webkit-flex-direction: column;
    flex-direction: column;
    width: calc(100% - 32px);
  }
  .global_img_style {
    height: unset !important;
    width: 311px !important;
  }
  .global_img_style1 {
    height: 150px !important;
  }
  // .spu_list_style {
  //   padding: 25px 15px !important;
  //   width: 37.5% !important;
  // }
  .intro_style {
    text-align: center;
  }
  .family_style {
    text-align: center;
    font-weight: bold;
    font-size: 14px;
  }
  .img_style {
    width: 80px !important;
  }
  .family_style1 {
    font-size: 12px !important;
    text-align: center !important;
  }
  .special_style {
    display: unset !important;
  }
  .special_des_style {
    width: unset !important;
  }
  .served_style {
    font-weight: bold;
    align-self: flex-start !important;
  }
  .p_style {
    display: none;
  }
  .important_style {
    font-weight: bold;
    font-size: 16px !important;
    align-self: flex-start !important;
  }
  .introduce_style {
    display: unset !important;
  }
  .fast_style {
    height: 610px !important;
    width: unset !important;
  }
  .fast_style.fa_style {
    height: 470px !important;
    width: unset !important;
  }
  .medical_style {
    padding: 10px !important;
    -webkit-flex-direction: column;
    flex-direction: column;
  }
  .me_style {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }
  .first_style > div {
    margin-bottom: 20px !important;
  }
  .question_style1 {
    font-weight: bold;
  }
  .process_style1 {
    margin-bottom: 15px !important;
  }
  .process_style2 {
    padding: 7px !important;
    font-size: 12px;
    height: 34px !important;
    width: 34px !important;
  }
  .lable_style1 {
    padding: 4px 7px !important;
  }
  .suitable_style1 {
    justify-content: space-around !important;
  }
  .vi_style {
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
  }
  .process_style {
    padding: 20px !important;
    -webkit-flex-direction: row-reverse;
    flex-direction: row-reverse;
  }
  .fast_img_style {
    width: unset !important;
    height: 240px !important;
  }
  .fast_style2 {
    text-align: center;
  }
  .online_style {
    margin: 0 auto;
  }
  // .spu_name_style {
  //   font-size: 14px !important;
  //   width: 124px !important;
  // }
  .spu_style1 {
    width: 100% !important;
    font-size: 12px !important;
    letter-spacing: 0.04em !important;
  }
  .spu_introduce_style {
    font-size: 12px !important;
    width: 110px !important;
    height: 34px !important;
  }
  .ques_style {
    font-size: 14px;
  }
  .pro_left_style::after {
    display: none !important;
  }
  .st_layout_style {
    width: 100% !important;
  }
  ::v-deep .st_layout_style .el-carousel__container {
    height: 360px !important;
  }
  .config_layout_style {
    height: 112px !important;
  }
}
.apply_style {
  background: #e0000f;
  color: #fff;
  padding: 20px 0;
  border-radius: 10px;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
  // width: 639px;
}
.config_layout_style {
  width: 100%;
  height: 200px;
  background: #a7dff2;
  border-radius: 8px;

  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-evenly;
  -webkit-align-items: center;
  align-items: center;
  position: relative;
}
.config_layout_title_style {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  align-items: center;
  row-gap: 7px;
}
.config_title_style {
  width: 192px;
  font-size: 16px;
  color: #cf2c25;
  font-weight: bold;

  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  align-items: center;
}
.config_button_style {
  width: 92px;
  height: 28px;
  line-height: 28px;
  background: #e0000f;
  border-radius: 17px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  cursor: pointer;
}
.has_config_style {
  width: 57px;
  height: 24px;
  line-height: 24px;
  background: #66b8d4;
  border-radius: 0px 8px 0px 8px;
  font-size: 12px;
  color: #ffffff;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
}
.lable_layout_style {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  border-radius: 8px 8px 0 0;
  width: 100%;
  background-color: #e9eff5;
}
.mouth_layout_style {
  position: relative;
  font-weight: bold;
  width: 50%;

  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  gap: 16px;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  padding: 24px 0;
  font-size: 16px;
  color: #223344;
  line-height: 2;
  cursor: pointer;
}
.mouth_layout_style::after {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: var(--lable-width);
  background: #e51c51;
  border-radius: 100px;
  content: "";
}
.mouth_layout_style:hover {
  background: #f2f2f2;
  color: rgba(34, 51, 68, 0.6);
}
.commonly_question_style {
  font-size: 14px;
  font-weight: bold;
}
.family_style1 {
  font-size: 14px;
}
.what_style1 {
  text-align: left;
  line-height: 2;
}
.age_eat_style {
  font-size: 12px;
}
.carousel_img_style {
  height: 240px;
}
.num_style {
  font-size: 17px;
}
.first_bold_style {
  font-size: 20px;
  font-weight: bold;
  line-height: 2;
}
.first_bold_next_style {
  font-size: 20px;
  font-weight: bold;
  line-height: 2;
  margin-bottom: 24px;
}
.first_bold_style1 {
  font-weight: bold;
  font-size: 14px;
  line-height: 2;
  margin-bottom: 24px;
}
.fast_desc_style {
  line-height: 1.6;
}
.st_layout_style {
  width: 50%;
}
// ::v-deep .st_layout_style .el-carousel__container {
//   height: 500px;
// }
 .el-carousel__container {
  height: 500px;
}
.st_style1 {
  margin: 20px auto 0;
  // width: 363px;
  text-align: center;
  font-size: 24px;
}
.st_style {
  font-size: 10px;
}
.p_style {
  color: rgba(0,0,0,.39);
  font-size: 22px;
  font-weight: bold;
}
.spu_introduce_style {
  color: #223344;
  font-size: 15px;
  width: 230px;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;

  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  // height: 34px;
}
.lable_style {
  width: 100%;

  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-around;
}
.lable_style1 {
  padding: 9px 20px;
  font-size: 9px;
  color: #1b2a7e;
  background-color: #e9eff5;
  border-radius: 25px;
}
.spu_style1 {
  height: 35px;
  line-height: 35px;
  text-align: center;
  width: 100%;
  font-size: 16px;
  color: #fff;
  letter-spacing: 2px;
  background-color: #1161BA;
  border-radius: 10px;
  cursor: pointer;
}
.spu_name_style {
  color: #1161BA;
  font-size: 16px;
  font-weight: 400;
}
.spu_coll_style {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  // background: #e9eff5;
  border-radius: 8px;
  gap: 44px;
  justify-content: flex-start;
  margin-bottom: 32px;
}
.spu_list_style > div:not(:last-child) {
  margin-bottom: 20px;
}
.spu_list_style {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  align-items: center;
  // padding: 30px 30px 35px;
  // border: 1px solid #78b2e1;
  // border-radius: 8px;
  background: #fff;
  max-width: 252px;
}
.spu_img_style {
  width: 250px;
}
.logo_img_style {
  width: 144px;
}
.app_img_style {
  height: 320px;
}
.fast_img_style {
  height: 220px;
}
.i_style {
  width: 70%;
}
.img_style {
  width: 40%;
}
.enter_style {
  background: #000;
  color: #fff;
  padding: 9px 23px;
  border-radius: 6px;
  font-weight: bold;
}
.question_style1 {
  box-sizing: border-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  align-items: center;
  border: 1px solid #e5e9f0;
  padding: 20px;
  width: 616px;
  height: 208px;
  background: #FFFFFF;
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #1161BA;
  margin:0 auto 50px;
  cursor: pointer;
  gap: 8px;
  font-size: 100px;
}
// .question_style {
//   box-sizing: border-box;
//   width: 100%;
//   padding: 24px;
//   gap: 24px;
//   background: #fff;

//   display: -webkit-flex;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-flex-direction: column;
//   flex-direction: column;
//   -webkit-align-items: center;
//   align-items: center;
//   margin-bottom: 40px;
//   border-radius: 10px;
// }
.fast_style1 {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
}
.fast_style2 {
  margin-bottom: 8px;
}
.fast_style {
  background: #fff;
  width: 50%;
  height: 500px;
  border-radius: 8px;
  padding: 24px;
}
.important_style {
  text-align: left;
  font-size: 18px;
  margin-bottom: 32px;
}
.served_style {
  margin-bottom: 16px;
  font-size: 18px;
  width: 100%;
}
.v_style {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}
.vip_style {
  color: #e51c51;
}
.intro_style {
  font-size: 18px;
  text-align: center;
  line-height: 2;
}
.int_style {
  margin-bottom: 16px;
  text-align: center;
}
.in_style {
  margin-bottom: 32px;
}
.content_style {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  align-items: center;
  // background: #f5f6f7;
}

.content_style > div {
  // max-width: 960px;
  // max-width: 1280px;
}

.me_style {
  width: 50%;

  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
}

.title_style {
  align-self: flex-start;
  font-size: 18px;
  margin-bottom: 24px;
}

.body_style {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  align-items: center;
  background: #f5f6f7;
}

.des_style {
  box-sizing: border-box;
  width: 100%;

  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-around;
  -webkit-align-items: center;
  align-items: center;
  background: #e60012;
  color: #fff;
  border-radius: 10px;
  padding: 40px 80px;
  font-size: 24px;
  line-height: 1.75;
  margin: 32px 0;
}

.carousel_style {
  width: 300px;
  height: 270px;
}

.des_style1 {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 16px;
}

.online_style {
  height: 45px;
  line-height: 45px;
  border-radius: 99999px;
  width: 160px;
  background-color: #e04f5b;
  text-align: center;
  font-size: 14px;
}

.step_style {
  width: 20%;
}

.global_style {
  width: calc(100% - 32px);

  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-around;
  -webkit-align-items: center;
  align-items: center;
  background: #8fd0e4;
  border-radius: 10px;
  padding: 24px 16px 0 16px;
  margin-bottom: 32px;
}

.global_img_style {
  height: 132px;
  padding-bottom: 16px;
}

.global_img_style1 {
  height: 180px;
}

.spu_style {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.package_style {
  width: 100%;
  margin-top: 16px;
}

.package_style1 {
  width: 100%;
  cursor: pointer;
}

.suitable_style {
  background: #fff;
  padding: 32px;
  border-radius: 10px;
  margin-bottom: 32px;
  width: 100%;
  box-sizing: border-box;
}

.family_style {
  text-align: center;
  font-weight: bold;
  margin-bottom: 16px;
}

.suitable_style1 {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
}

.suitable_style2 {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  -webkit-align-items: center;
  align-items: center;
  row-gap: 16px;
}

.spec_style {
  width: 100%;
  margin-bottom: 16px;
}

.special_style {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-around;
  -webkit-align-items: center;
  align-items: center;
  gap: 20px;
  margin-bottom: 40px;
}

.special_des_style {
  background: #fff;
  border-radius: 10px;
  width: 30%;
  height: 330px;
  padding: 20px;
}
.according_style {
  font-size: 14px;
}

.special_des_style2 {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-around;
  -webkit-align-items: center;
  align-items: center;
  margin-bottom: 30px;
}

.process_style {
  box-sizing: border-box;
  width: 100%;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
  border: 3px solid #1161BA;
  margin-bottom: 90px;
  border-radius: 8px;
  // padding: 32px;
  padding: 30px 140px 30px 69px;
}
.pro_left_style {
  position: relative;

  z-index: 1;
}
.pro_left_style::after {
  content: "";
  position: absolute;
  top: 44px;
  left: 30px;
  width: 4px;
  height: calc(100% - 88px);
  background: #e5e9f0;
  z-index: -1;
}

.process_style1 {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  gap: 40px;
  margin-bottom: 12px;
  cursor: pointer;
}

.process_style2 {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-direction: column;
  flex-direction: column;
  justify-content: center;
  -webkit-align-items: center;
  align-items: center;
  border-radius: 200px;
  background: #ffffff;
  border: 1px solid #e5e9f0;
  color: #778899;
  font-size: 12px;
  font-weight: bold;
  width: 60px;
  height: 60px;
  line-height: 1;
}

.introduce_style {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-around;
  -webkit-align-items: center;
  align-items: center;
  margin-bottom: 32px;
  gap: 20px;
}

.medical_style {
  box-sizing: border-box;
  width: 100%;

  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  color: #fff;
  gap: 32px;
  padding: 40px;
  background: #e51c51;
  border-radius: 8px;
  margin-bottom: 96px;
}

.medical_href_style {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
  -webkit-align-items: center;
  align-items: center;
  cursor: pointer;
  margin-bottom: 16px;
}
// 新版
.index_topimg{
  width: 100%;
}
.index_topimg img{
  width: 100%;
  display: block;
  margin:39px auto 66px;
}
.index_bluetit{
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 39px;
  color:#1161BA;
  text-align: center;
}
.index_bluetit.mb60{
  margin-bottom: 60px;
}
.index_content{
  width:1200px;
}

.index_pzydescribe{
  text-align: center;
}
.index_blueborder{
  position: relative;
  width: 100%;
  padding:65px 0 70px;
  margin-bottom: 70px;
  border-radius: 20px;
  border:3px solid #1161BA;
}
.index_pzydescribe_text{
  font-size: 28px;
  margin-bottom: 10px;
  letter-spacing: 2px;
}
.index_pzydescribe_boldtext{
  font-weight: bold;
  line-height: 35px;
  letter-spacing: 3px;
  font-size: 30px;
  padding:20px 0 35px;
}
.index_bluecircle{
  width: 212px;
  height: 212px;
  border-radius: 50%;
  border:3px solid #1161BA;
  position: absolute;
  background: #fff;
}
.index_pzydescribe1{
  top:-54px;
  left:46px;
}
.index_pzydescribe2{
  top:108px;
  right:63px;
}
.index_pzydescribe3{
  bottom:68px;
  left:31px;
}
.index_bluecircle img{
  position: absolute;
  width: 155px;
  height: auto;
  left:0;
  top:0;
  right:0;
  bottom:0;
  margin:auto;
}
.index_specials1{
  top:-67px;
  left:137px;
}
.index_specials1{
  top:-67px;
  left:137px;
}
.index_specials2{
  top:38px;
  right:32px;
}
.index_specials2.index_bluecircle img{
  width: auto;
  height: 165px;
}
.index_specials3{
  top:197px;
  left:27px;
}
.index_specialcont{
  width: 670px;
  margin-left:353px;
}
.index_specialtit{
  font-size: 30px;
  letter-spacing: 3px;
  margin-bottom: 20px;
  font-weight: bold;
}
.index_specialtit span.num{
  color:#FF6849;
}
.index_specialtit:nth-child(1) span.num{
  color:#EC3F3C;
}
.index_specialtxt{
  font-size: 24px;
  letter-spacing: 2px;
  margin-bottom: 35px;
}
.index_specialtxt.first{
  width: 492px;
}
.m_style{
  width: 363px;
  display: block;
  margin:30px auto 0;
}

.index_attention{
  padding:29px 0 25px 139px;
  border:1px solid #67B5E1;
  position: relative;
  margin-bottom: 31px;
  border-radius: 20px;
  box-shadow: 0px 2px 2px 0px rgba(0,0,0,0.25);
}
.index_attentionleft{
  position: absolute;
  top:21px;
  left:0;
  width: 119px;
  height: 42px;
  line-height: 42px;
  border-radius: 0px 20px 20px 0px;
  background-color: #B01D2E;
   color:#fff;
   font-size: 25px;
   color:#F3F2FA;
   text-align: center;
}
.index_attention_txt{
  font-size: 20px;
  color: #1161BA;
  margin-bottom: 10px;
}
.index_medicinetit{
  font-size: 35px;
  font-weight: bold;
  margin-bottom: 27px;
}

.index_mdeicinebox{
  font-size: 0;
  text-align: center;
  margin:68px 0 70px;
}
.idex_medicinebtn{
  display: inline-block;
  width: 311px;
  height: 80px;
  line-height: 80px;
  text-align: center;
  background: #FFFFFF;
  font-size: 30px;
  color: #1161BA;
  box-shadow: 1px 1px 10px 2px #B5B5B5;
  border-radius: 30px 30px 30px 30px;
  margin-right: 23px;
}
.idex_medicinebtn.blue{
  background: #1161BA;
  color:#fff;
  font-weight: bold;
  height: 80px;
  line-height: 80px;
  margin-right: 0;
  cursor: pointer;
}
.question_style1 .el-icon-question{
  font-size: 100px;
}
.commonly_question_style{
  font-size: 30px;
  color: #1161BA;
  font-weight: normal;
}
.index_medicineborder{
  border:1px solid #A2DDE9;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 1px 1px 0px rgba(0,0,0,0.25);
}
.index_medicinebcont{
  padding:10px 20px;
}
.index_guge{
  font-size: 14px;
  margin-bottom: 5px;
  color:rgba(0,0,0,0.56)
}
// 新加的药包
.two_medicinebag{
    // padding:35px 20px;
}
.clearfix{
  clear: both;
  overflow: hidden;
}
.fl{
  float: left;
}
.fr{
  float:right;
}
.twobag{
  width: 50%;
  box-sizing: border-box;
  float: left;
   padding:35px 10px 50px 20px;
}
// .twobag.on{
//   background: #FFFBED;
// }
.twobagtop{
  width: 100%;
  height: auto;
  margin-bottom: 15px;
  background-color: #FFFFFF;
}
.twobagimg{
  width: 100%;
}
.twobagbottext{
  padding:15px 20px 10px 26px;
}
.twobagtxtbox{
  width:calc(100% - 90px);
}
.twobgtxt{
  font-size: 20px;
  color:#1161BA;
  margin-bottom: 10px;
}
.twobgtxt span{
  font-size: 40px;
  display: inline-block;
  margin-left:20px;
  color:#1161BA;
}
.twobgtxtbtn{
  width: 86px;
  height: 78px;
  padding:0 15px;
  border-radius: 10px;
  background: #1161BA;
  color:#fff;
  text-align: center;
  padding:15px 24px;
  font-size: 18px;
  box-sizing: border-box;
}
.twobagleft{
  display: inline-block;
  box-sizing: border-box;
  width: calc(50% - 8px);
  height: 83px;
  border-radius: 30px;
  margin-right: 15px;
  box-shadow:  2px 3px 10px #B5B5B5;
  font-size: 18px;
  padding:18px 50px;
  color: #1161BA;
  text-align: center;
  background-color: #fff;
}
.twobagleft.on{
  background-color: #1161BA;
  color:#fff;
  font-size: 20px;
  line-height: 49px;
  margin-right: 0;
  vertical-align: top;
}
.twobaglist{
  // background-color: #FFFBED;
  padding:0 0 0 17px;
  box-sizing: border-box;
}
.twobgitem{
  cursor: pointer;
}
.twobags{
  width: 535px;
  height:50px;
  line-height:50px;
  border-radius: 10px;
  background-color: #fff;
  color:#1161BA;
  font-size: 20px;
  border:1px solid #1161BA;
  margin:0 auto 50px;
  text-align:center;
}
.phone.tbl{
    display: none;
  }
  .pc.tbl{
    display: block;
  }
@media screen and (max-width: 1250px) {
   .index_content{
    width: 90%;
   }
   .index_service_tit{
    font-size: 20px;
   }
   .index_service_desc{
    height: 78px;
   }
   .index_service_item{
    padding-bottom: 50px;
   }
   .index_service_item img{
    width: 110px;
   }
   .index_pzydescribe_text{
    font-size: 20px;
    margin-bottom: 5px;
   }
   .index_bluecircle {
    width: 130px;
    height: 130px;
   }
   .index_bluecircle img{
    width: 100px;
   }
   .index_pzydescribe_boldtext{
    font-size: 25px;
    padding:15px 0 25px;
   }
   .index_bluetit{
    font-size: 35px;
   }
   .index_pzydescribe1{
    left:17px;
    top:-30px
   }
   .index_pzydescribe2{
    top:100px;
    right:16px;
   }
   .index_specials1{
    left:15px;
    top:-30px;
   }
   .index_specialtit{
    font-size: 24px;
    margin-bottom: 10px;
   }
   .index_specialtxt{
    font-size: 20px;
    margin-bottom: 25px;
   }
   .index_specialcont{
    width: 70%;
    margin-left: 200px;
   }
   .index_specials2.index_bluecircle img{
    height: 130px;
   }
   .p_style{
    font-size: 20px;
   }
   .process_style1{
    gap:25px;
   }
   .st_style1{
    font-size: 22px;
   }
   .process_style{
    padding-right: 50px;
   }
   .st_layout_style{
    width: calc(100% - 287px);
   }
   .index_cooperate_item{
    width: 32%;
    margin-right:2%;
   }
   .idex_medicinebtn{
    width: 30%;
    font-size: 24px;
   }
   .idex_medicinebtn.blue{
    font-size: 25px;
   }
   .twobagleft{
    padding:15px 20px;
    height: auto;
  }
  .twobgtxt{
    font-size: 16px;
    margin-bottom: 5px;
  }
  .twobgtxt span{
    margin-left: 10px;
    font-size: 30px;
  }
 
}
@media screen and (max-width: 1000px) {
  .index_specialtxt.first{
    width:70%;
  }
  .twobag{
    width: 100%;
    padding:20px 5px 30px 10px;
  }
  .twobgtxt{
    font-size:14px;
    margin-bottom: 0;
  }
  .twobagbottext{
    padding:5px 10px;
  }
  .twobagbottext span{
    margin-left:1px;
  }
  .twobagtxtbox{
    // width:100%;
    // float: none;
  }
  .twobgtxtbtn{
    width:60px;
    // float: none;
    height:60px;
    font-size: 14px;
    padding:10px 15px;
    border-radius: 5px;
  }
  .twobagleft{
    display:inline-block;
    padding:10px;
    // width: 90%;
    font-size: 14px;
  }
  .twobagleft.on{
    font-size: 14px;
    margin-right:auto;
    line-height: 38px;
  }
  .twobags{
    width: 60%;
    height: 38px;
    line-height:38px;
    font-size: 16px;
    margin:30px auto 0;
  }
  .phone.tbl{
    display: block;
  }
  .pc.tbl{
    display: none;
  }
  .phone.tbl .index_medicinetit{
    margin-top: 20px;
  }
}
@media screen and (max-width: 880px) {
 .index_service_tit{
  font-size: 17px;
 }
}
@media screen and (max-width: 768px) {
   .index_bluetit{
    font-size: 20px;
    margin-bottom: 20px;
   }
   .index_topimg img{
    margin:20px auto 30px;
   }
   .index_service_item{
    width: 100%;
    margin-bottom: 15px;
    padding:15px 15px 40px;
    border-width: 1px;
    margin-right: 0;
   }
   .index_service_item  img{
    width: 100px;
   }
   .index_service_tit{
    font-size: 18px;
   }
   .index_service_desc{
    font-size: 12px;
    height: auto;
   }
   .index_service_item img{
    bottom:0
   }
   .index_service{
    margin-bottom: 40px;
   }
   .index_blueborder{
    border-width: 1px;
    padding:30px 0;
    margin-bottom: 50px;
   }
   .index_bluecircle{
    border-width: 1px;
    width: 70px;
    height: 70px;
   }
   .index_bluecircle img{
    width: 54px;
   }
   .index_pzydescribe_text{
    font-size: 12px;
   }
   .index_pzydescribe_boldtext{
    font-size: 14px;
    line-height: 1;
    padding:10px 0 15px;
   }
   .index_pzydescribe1{
    top:-20px;
   }
   .index_pzydescribe2{
    top: 80px;
    right: 0px;
   }
   .index_pzydescribe3{
    left:5px;
    bottom:5px;
   }
   .index_specialcont{
    margin-left:40px;
   }
   .index_specialtit{
    font-size: 17px;
   }
   .index_specialtxt{
    font-size: 12px;
    margin-bottom: 5px;
   }
   .index_specialtxt.first{
    width: 70%;
   }
   .index_specials2.index_bluecircle img{
    height: 60px;
   }
   .index_specials1{
    top:-40px;
   }
   .index_specials3{
    right:5px;
    left:auto;
    top:220px;
   }
   .index_bluetit.mb60{
    margin-bottom: 25px;
   }
   .process_style{
    border-width: 1px;
   }
   .m_style{
    width: 90%;
   }
   .st_style1{
    width: 90%;
    font-size: 14px;
   }
   .index_blacktitdes{
    font-size: 14px;
    margin-bottom:10px;
   }
   .index_attentionleft{
    font-size: 12px;
    width: 65px;
    height: 30px;
    line-height: 30px;
    top: 15px;
   }
   .index_attention{
    padding:20px 10px 10px 80px;
   }
   .index_attention_txt{
    font-size: 14px;
    margin-bottom: 6px;
   }
   .index_medicinetit{
    font-size: 18px;
    margin-bottom: 10px;
   }
   .spu_coll_style{
    gap:20px;
   }
   .spu_list_style{
    width: calc(50% - 10px);
   }
   .spu_img_style{
    width: 100%;
    height:auto;
   }
   .index_medicinebcont{
    padding:10px 5px;
   }
   .spu_name_style{
    font-size: 14px;
   }
   .index_guge.index_fl{
    min-height: 35px;
   }
   .idex_medicinebtn{
    width: 90%;
    margin: 0 auto 20px;
    font-size: 16px;
    height: 50px;
    line-height: 50px;
   }
   .idex_medicinebtn.blue{
    font-size: 16px;
    height: 50px;
    line-height: 50px;
   }
   .spu_coll_style{
    margin-bottom: 0;
   }
   .index_mdeicinebox{
    margin-bottom: 40px;
    margin-top: 20px;
   }
   .index_cooperate_group{
    padding:20px 0 40px;
   }
   .index_cooperate_item{
    width: calc(50% - 8px);
    margin-right: 16px;
    margin-bottom: 10px;
   }
   .index_cooperate_item:nth-child(2n){
    margin-right: 0;
   }
   .index_cooperate_item:nth-child(3){
    margin-right: 16px;
   }
   .question_style1{
    width: 60%;
    height: 90px;
    padding:10px;
   }
   .question_style1 .el-icon-question{
    font-size: 35px;
   }
   .commonly_question_style{
     font-size: 14px;
   }
   .index_specialtit{
    overflow:hidden;
    zoom:1;
   }
   .num{
    width: 25px;
    float: left;
    vertical-align: middle;
    margin-top: 3px;
   }
   .snumtit{
    width: calc(100% - 25px);
    float: left;
   }
   .index_specialtxt{
    padding-left: 25px;
   }
   .index_specials2{
    right:5px;
   }
}
// 英文
.english{
  .index_service_tit{
      height: 100px;
  }
  .index_service_desc{
      height: 76px;
  }
  .index_pzydescribe1{
      top: -45px;
      left:-100px;
  }
  .index_pzydescribe_text{
      font-size:21px;
  }
  .index_pzydescribe2 {
      top: 133px;
      right: 35px;
  }
  .index_specials1 {
      left: 60px;
  }
  .index_specials2 {
      right: 2px;
  }
  .twobagleft,.twobgtxtbtn{
      padding:18px 10px;
  }
  .twobagleft.on{
      padding:18px 20px;
      font-size:18px;
  }
  .st_style1{
      font-size: 20px;
  }
  @media screen and (max-width: 1251px) {
    .index_service_tit{
      height: 55px;
    }
    .index_pzydescribe1{
      left:47px;
    }
    .twobagleft{
      font-size: 15px;
    }
    .twobagleft.on{
      line-height:34px;
      font-size: 16px;
      padding:18px 15px;
    }
  }
  @media screen and (max-width: 1210px) {
    .index_pzydescribe3{
      left:0px;
      bottom:110px;
    }
  }
  @media screen and (max-width: 1125px) {
    .index_specials2{
      top:82px;
    }
    .twobgtxt{
      font-size: 14px;
    }
  }
  @media screen and (max-width: 1115px) {
   .twobagleft.on{
    line-height: 34px;
    font-size: 15px;
   }
  }
  @media screen and (max-width: 1107px) {
   .twobagleft.on{
    line-height:34px;
    // padding:18px 30px;
   }
   .twobagleft{
    font-size: 13px;
   }
  }
  @media screen and (max-width: 1100px) {
    .index_specials2{
      top:82px;
    }
  }
  @media screen and (max-width: 1060px) {
    .twobagleft.on{
      font-size: 13px;
   }
   .twobgtxt span{
    font-size: 24px;
   }
  }
  @media screen and (max-width: 1025px) {
    .twobagleft.on{
      line-height: 30px;
    }
  }
  @media screen and (max-width: 1020px) {
    .m_style{
      width: 100%;
    }
    .st_style1{
      font-size: 17px;
    }
  }
  @media screen and (max-width: 1000px) {
    .index_specials2{
      top:97px;
    }
    .index_specials1{
      left:-10px;
    }
    .index_pzydescribe1{
      left:-5px;
    }
    .index_pzydescribe2{
      right:-1px;
    }
    .index_pzydescribe3{
      left:-10px;
    }
    .index_specialtxt.first{
      width: 370px;
    }
    .twobgtxtbtn{
      padding:12px 5px;
    }
    .index_service_tit{
      font-size: 18px;
      height: 45px;
    }
    .index_service_desc{
      font-size: 12px;
    }
    .index_specialcont{
      margin-left: 170px;
    }
    .index_specials3{
      left:3px;
    }
    .twobagleft{
      line-height:25.5px;
    }
    .index_pzydescribe_text{
      width: 70%;
      margin:0 auto;
    }
  }
  @media screen and (max-width: 900px){
    
  }
  @media screen and (max-width: 870px){
    .index_service_desc{
      width: calc(100% - 103px);
    }
    .index_service_tit{
      height: 55px;
    }
    .twobagleft.on{
    line-height: 25.5px;
    }
   
  }
  @media screen and (max-width: 860px){
    .index_specials2{
      top:114px;
      right:-10px;
    }
  }
  @media screen and (max-width: 768px){
    .twobagleft{
      line-height: normal;
    }
    .twobagleft.on {
      line-height: normal;
      padding:15px;
    }
    .index_specialtxt.first{
      width: 80%;
    }
    .index_service_tit{
      height: auto;
    }
    .index_specialcont{
      margin-left: 55px;
    }
    .index_pzydescribe1 {
      top:-24px;
      left:-12px;
    }
    .index_pzydescribe2{
      right:-26px;
      top:70px;
    }
    .index_specials1{
      left: -18px;
      top:-20px;
    }
    .index_specials2{
      right:-8px;
    }
    .index_pzydescribe3{
      bottom:-40px;
    }
    .twobagleft{
      font-size: 12px;
      height: 60px;
      padding:10px;
    }
    .index_pzydescribe_text{
      font-size: 12px;
      width: 80%;
      margin: 0 auto;
    }
    .cat_style{
        margin-right: 25px;
    }
   .twobgtxtbtn{
    padding:14px 5px;
   }
  }
}
// 日文
.japanese{
  .twobgtxtbtn{
      padding:15px 10px;
  }
  .index_service_tit{
      height: 120px;
  }
  .index_service_desc{
      height: 76px;
  }
  .index_pzydescribe1{
      left:21px;
  }
  .index_pzydescribe2{
      right:30px;
  }
  .st_style1{
      font-size: 20px;
  }

  @media screen and (max-width: 1250px) {
    .index_service_tit{
      height: 55px;
    }
  }
  @media screen and (max-width: 1110px) {
    .index_service_tit{
     font-size: 18px;
    }
    .index_service_desc{
      width:calc(100% - 100px);
    }
    .twobagleft{
      font-size: 16px;
    }
  }
  @media screen and (max-width: 1000px) {
    .index_specialtxt.first{
      width: 370px;
    }
    .twobgtxtbtn{
      padding:12px 5px;
    }
    .index_service_tit{
      font-size: 16px;
    }
    .index_service_desc{
      font-size: 12px;
    }
    .index_specialcont{
      margin-left: 145px;
    }
    .index_specials3{
      left:3px;
    }
    .twobagleft{
      line-height: 38px;
    }
  }
  @media screen and (max-width: 900px){
    .m_style{
      width: 100%;
    }
    .st_style1{
      font-size: 18px;
    }
  }
  @media screen and (max-width: 768px){
    .twobagleft{
      line-height: normal;
      height: 58px;
    }
    .twobagleft.on {
      line-height: 38px;
    }
    .index_specialtxt.first{
      width: 80%;
    }
    .index_service_tit{
      height: auto;
    }
    .index_specialcont{
      margin-left: 60px;
    }
    .index_pzydescribe1 {
      top:-45px;
    }
    .index_pzydescribe2{
      right:-39px;
      top:70px;
    }
    .index_specials2{
      right:-8px;
    }
    .index_pzydescribe3{
      bottom:-40px;
    }
    .twobagleft{
      font-size: 14px;
    }
  }
}
</style>